import type { Theme } from '@mui/material/styles';

const getTextField = () => ({
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      '&>div': {
        borderRadius: theme.shape.borderRadius,
        border: 1,
        minHeight: 40,
        ':focus-visible': {
          border: 2,
        },
      },
    }),
    error: ({ theme }: { theme: Theme }) => ({
      input: {
        color: theme.palette.semantic.interactive.critical.default,
      },
    }),
  },
});
export default getTextField;
